import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["ref"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Flex } from '@chakra-ui/react';
import { Controller } from 'react-hook-form';
import { FORM_FIELD_TYPES } from '../formConstants';
import Input from './../../Input';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FormInput(_ref) {
  var _formField$props, _errors$formField$nam;
  var control = _ref.control,
    formField = _ref.formField,
    errors = _ref.errors;
  var errorStyles = (_formField$props = formField.props) !== null && _formField$props !== void 0 && _formField$props.useTooltip && !!(errors !== null && errors !== void 0 && (_errors$formField$nam = errors[formField.name]) !== null && _errors$formField$nam !== void 0 && _errors$formField$nam.message) ? tooltipErrorStyles : {};
  var emailFieldProps = formField.type === FORM_FIELD_TYPES.INPUT_EMAIL ? {
    inputMode: 'email',
    autoCapitalize: 'off',
    autoCorrect: 'off',
    autoComplete: 'email'
  } : {};
  return _jsx(Flex, _objectSpread(_objectSpread({
    direction: "column"
  }, _objectSpread(_objectSpread(_objectSpread({}, defaultStyles), formField.styles), errorStyles)), {}, {
    "data-testid": formField.testid,
    "data-fieldname": formField.name,
    children: _jsx(Controller, {
      name: formField.name,
      control: control,
      render: _ref2 => {
        var _errors$formField$nam2;
        var field = _ref2.field;
        var _ = field.ref,
          extraPropsField = _objectWithoutProperties(field, _excluded);
        return _jsx(Input, _objectSpread(_objectSpread(_objectSpread({}, formField.props), extraPropsField), {}, {
          type: formField.type === FORM_FIELD_TYPES.INPUT_EMAIL ? FORM_FIELD_TYPES.INPUT_TEXT : formField.type,
          value: extraPropsField.value || '',
          placeholderText: formField.label,
          label: formField.label,
          error: errors === null || errors === void 0 || (_errors$formField$nam2 = errors[formField.name]) === null || _errors$formField$nam2 === void 0 ? void 0 : _errors$formField$nam2.message,
          emailFieldProps: emailFieldProps
        }));
      }
    })
  }));
}
var tooltipErrorStyles = {
  marginBottom: 'var(--chakra-space-6xl)'
};
var defaultStyles = {
  marginBottom: 'var(--chakra-space-md)'
};